export const getDashboardLink = (company, accountType, claimGroup = null) => {
  if (company.dashboard_type === 'business_unit_intensity_breakdown' && claimGroup) {
    return `/${accountType}/claim_groups/${claimGroup.id}/regular_realtime_dashboard/${company.id}`;
  }

  if (claimGroup) {
    return `/${accountType}/claim_groups/${claimGroup.id}/dashboard/${company.id}`;
  }
 
  return company.dashboard_type === 'business_unit_intensity_breakdown'
    ? `/${accountType}/regular_realtime_dashboard/${company.id}`
    : `/${accountType}/dashboard/${company.id}`;
};
